// La direccion de un archivo que viaja DENTRO de la app (crm-app/public/).
//
// POR QUE EXISTE
//
// Escribir "/logo/deskte-ocean.svg" pide ese archivo a la RAIZ del dominio.
// En app.deskte.com la raiz es la propia aplicacion y sale bien. En la demo
// publica, que vive en deskte.com/demo/app/, la raiz es el SITIO DE MARKETING:
// el logo que ve un cliente en la demo no es el que la demo lleva dentro, es
// el de website/logo/, que hoy existe con ese mismo nombre.
//
// O sea: funciona por coincidencia. El dia que alguien renombre o mueva
// website/logo/, la demo se queda sin logo — y no dara ningun error, solo un
// hueco. `import.meta.env.BASE_URL` es "/" en la compilacion normal y
// "/demo/app/" en la de la demo (VITE_BASE, crm-app/.env.demo), asi que esta
// funcion hace que cada compilacion pida SU copia y no dependa de la de al
// lado.
//
// SE USA para cualquier archivo de crm-app/public/ que se cite desde el
// JavaScript. En index.html no hace falta: ahi Vite reescribe las rutas solo.
//
// QUE SIGUE SIN USARLO, a proposito: AuthGate.jsx, SignaturePad.jsx y
// PublicResourcePortal.jsx tambien escriben "/logo/...". Son pantallas que la
// demo NO monta (la demo entra sin MSAL, y las paginas publicas del cliente no
// se enlazan desde ahi), asi que hoy no se rompen. Si alguna llega a verse bajo
// una subcarpeta, esta es la funcion que necesitan.

/**
 * @param {string} ruta ruta dentro de crm-app/public, con o sin barra inicial
 * @returns {string} la ruta con el prefijo del build
 */
export function assetUrl(ruta) {
  const base = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.BASE_URL) || '/';
  return base + String(ruta || '').replace(/^\/+/, '');
}
